import { QueryClient } from '@tanstack/react-query';
import {
    bumpSentimentGeneration,
    isSentimentQuery,
} from '@tn/foundation/entities/hubs/hooks/sentiment/invalidateSentimentQueries';
import { appLogger } from '@tn/foundation/utils/app-logger/appLogger';

/** Never throws: a failed rating reset must not stop the auth change that triggered it. */
export async function resetSentimentAfterAuthChange(queryClient: QueryClient): Promise<void> {
    try {
        bumpSentimentGeneration();
        await queryClient.resetQueries({ predicate: isSentimentQuery });
    } catch (error) {
        appLogger.error(
            'Sentiment cache reset failed after auth change',
            { component: 'resetSentimentAfterAuthChange' },
            error,
        );
    }
}
